import { getUrlPara } from './url'
import utils from './index'

export function wxConfig(type = 0) {
  console.log(`wx share config with ${type == 1 ? '有道天天读' : '有道树屋'}`)
  return new Promise(resolve => {
    if (!utils.isWeixin()) {
      return
    }
    let scriptSrc = '/api/mob/getJsSdkConfig.html'
    if (type == 1 || utils.isIreadingDomain()) {
      scriptSrc = '/api/mob/getIreadingJsSdkConfig.html'
    } else if (type == 2 || utils.isPublishDomain()) {
      scriptSrc = '/api/wx/h5/config/getJsSdkConfig' // publish.youdao.com
    }
    const sc = document.createElement('script')
    sc.type = 'text/javascript'
    sc.charset = 'UTF-8'
    sc.onload = () => {
      let debug = false
      if (getUrlPara('debug') == 1) {
        debug = true
      }
      if (typeof _wx_auth != 'undefined') {
        wx.config({
          debug: debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: _wx_auth.appId, // 必填，公众号的唯一标识
          timestamp: _wx_auth.timestamp, // 必填，生成签名的时间戳
          nonceStr: _wx_auth.nonceStr, // 必填，生成签名的随机串
          signature: _wx_auth.signature, // 必填，签名
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'scanQRCode'
          ], // 必填，需要使用的JS接口列表
          openTagList: ['wx-open-launch-app']
        })
        console.log('wx config 完成')
        resolve()
      }
    }
    sc.src = scriptSrc
    document.body.appendChild(sc)
  })
}

function is_weixn() {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
export function getWechatVertion() {
  var version = ''
  if (is_weixn()) {
    var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
    if (wechatInfo && wechatInfo.length > 1) {
      // 获取微信的版本号
      version = wechatInfo[1]
    }
  }
  return version
}
/**
 * {
 *  title: '', // 分享标题
    desc: '', // 分享描述
    link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: '', // 分享图标
    success: function () {
      // 设置成功
    }
  }
 */
export function share(opt = {}, type) {
  // wxConfig(type).then(() => {
  wx.ready(function () {
    //需在用户可能点击分享按钮前 就先调用
    wx.updateAppMessageShareData(opt)
    if (opt.shift) {
      opt.title = opt.desc
    }
    wx.updateTimelineShareData(opt)
  })
  // })
}
